var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { avoidAuthToken } from "@adapters/constants";
import { encryptionEnable } from "@adapters/infrastructures/encryption";
import TOCJourneyConfigURL from "@adapters/infrastructures/urlConfig/TOCJourney/TOCJourneyURL";
import AMOStatus from "@domains/features/TOCJourney/mapper/AMOStatusMapper";
import brokerChargesMapper from "@domains/features/TOCJourney/mapper/BrokerChargesMapper";
import CheckMarginMapper from "@domains/features/TOCJourney/mapper/CheckMarginMapper";
import { MultiQuoteMapper } from "@domains/features/TOCJourney/mapper/MultiQuoteMapper";
import orderDetailsMapper from "@domains/features/TOCJourney/mapper/orderDetailsMapper";
import placeNormalTradeMapper from "@domains/features/TOCJourney/mapper/placeNormalTrade";
import OfsTradeMapper from "@domains/features/TOCJourney/mapper/OfsTradeMapper";
import TocSchemeDetailMapper from "@domains/features/TOCJourney/mapper/TocSchemeDetailMapper";
import switchDetailsMapper from "@domains/features/TOCJourney/mapper/switchDetailsMapper";
import { EInvestmentType } from "@frameworks/shared-library/components/TransactionJourney/MutualFund/MutualFundConstant";
var TOCJourney = /** @class */ (function () {
    function TOCJourney(http, accountDetails) {
        this.http = http;
        this.accountDetails = accountDetails;
        //change the flag in fundtransfer as well to enable juspay
        this.jusPayFlag = false;
    }
    TOCJourney.prototype.mfPauseResumeOrder = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, resp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(TOCJourneyConfigURL.MFPauseResumeOrder);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "PUT",
                                url: url.toString(),
                                body: req,
                                encryption: encryptionEnable,
                            })];
                    case 1:
                        resp = _a.sent();
                        return [2 /*return*/, resp.data];
                }
            });
        });
    };
    TOCJourney.prototype.mfCancelOrder = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(TOCJourneyConfigURL.MFCancelOrder);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "PUT",
                                url: url.toString(),
                                body: req,
                                encryption: encryptionEnable,
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    TOCJourney.prototype.getModifyPreApplyIpo = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(TOCJourneyConfigURL.preApplyIPO);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "PUT",
                                url: url.toString(),
                                body: req === null || req === void 0 ? void 0 : req.body,
                                getGauth: req === null || req === void 0 ? void 0 : req.getGauth,
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result === null || result === void 0 ? void 0 : result.data];
                }
            });
        });
    };
    TOCJourney.prototype.getIpoPreApply = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(TOCJourneyConfigURL.preApplyIPO);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req.body,
                                getGauth: req === null || req === void 0 ? void 0 : req.getGauth,
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data];
                }
            });
        });
    };
    TOCJourney.prototype.getModifyIpo = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(TOCJourneyConfigURL.applyIPO);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "PUT",
                                url: url.toString(),
                                body: req === null || req === void 0 ? void 0 : req.body,
                                getGauth: req === null || req === void 0 ? void 0 : req.getGauth,
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data];
                }
            });
        });
    };
    TOCJourney.prototype.getIpoCancel = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(TOCJourneyConfigURL.ipoCancel);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "PUT",
                                url: url.toString(),
                                body: req === null || req === void 0 ? void 0 : req.body,
                                getGauth: req === null || req === void 0 ? void 0 : req.getGauth,
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    TOCJourney.prototype.getIpoOtpRegister = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(TOCJourneyConfigURL.ipoOtpRegister);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result === null || result === void 0 ? void 0 : result.data];
                }
            });
        });
    };
    TOCJourney.prototype.getIpoOtpValidate = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(TOCJourneyConfigURL.ipoOtpValidate);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    TOCJourney.prototype.getIpoBankMaster = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(TOCJourneyConfigURL.ipoBankMaster);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                                avoidAuthToken: avoidAuthToken,
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    TOCJourney.prototype.getNcdIpoBankNames = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(TOCJourneyConfigURL.ncdipobankNames);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res === null || res === void 0 ? void 0 : res.data];
                }
            });
        });
    };
    TOCJourney.prototype.getIpoOtpLeads = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(TOCJourneyConfigURL.ipoOtpLeads);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    TOCJourney.prototype.mfPurchaseOrder = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(TOCJourneyConfigURL.mfPurchaseOrder);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                                encryption: encryptionEnable,
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    TOCJourney.prototype.getMfSipStartDate = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(TOCJourneyConfigURL.mfStartDate);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    TOCJourney.prototype.getMfFrequency = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(TOCJourneyConfigURL.sipFrequency);
                        url.searchParams.append("isin", req.isin);
                        url.searchParams.append("scmCd", req.scmCd);
                        url.searchParams.append("amcCd", req.amcCd);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    TOCJourney.prototype.getMFPurchaseDetails = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, payload, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(TOCJourneyConfigURL.MFPurchaseNew);
                        payload = __assign(__assign({}, req), { trxType: req.trxType === EInvestmentType.SWITCH ? "REDEMPTION" : req.trxType, type: req.trxType === EInvestmentType.SWITCH ? "R" : req.type });
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: payload,
                                encryption: encryptionEnable,
                            })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, TocSchemeDetailMapper(data, req.trxType)];
                }
            });
        });
    };
    TOCJourney.prototype.getNfoPurchaseDetails = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(TOCJourneyConfigURL.NfoPurchase);
                        url.searchParams.append("isin", req.isin);
                        url.searchParams.append("action", req.action);
                        if (req.scehmeCode)
                            url.searchParams.append("schCd", req.scehmeCode);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    TOCJourney.prototype.mfParticularHolding = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, _a, _b, _c, result;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = URL.bind;
                        _c = (_b = "".concat(TOCJourneyConfigURL.MFHolding, "/")).concat;
                        return [4 /*yield*/, this.accountDetails.getUserID()];
                    case 1:
                        url = new (_a.apply(URL, [void 0, _c.apply(_b, [_d.sent(), "/"]).concat(req.isin)]))();
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 2:
                        result = _d.sent();
                        return [2 /*return*/, result.data];
                }
            });
        });
    };
    TOCJourney.prototype.mfHoldingDetailData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(TOCJourneyConfigURL.MFHoldingDetails);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                                encryption: encryptionEnable,
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    TOCJourney.prototype.mfSchemeHoldingDetailData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(TOCJourneyConfigURL.MFSchemeHoldingDetails);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    TOCJourney.prototype.mfAllHoldings = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url, _a, _b, _c, result;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = URL.bind;
                        _c = (_b = "".concat(TOCJourneyConfigURL.MFHolding, "/")).concat;
                        return [4 /*yield*/, this.accountDetails.getUserID()];
                    case 1:
                        url = new (_a.apply(URL, [void 0, _c.apply(_b, [_d.sent()])]))();
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 2:
                        result = _d.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    TOCJourney.prototype.getMultiQuoteDetails = function (reqObj) {
        return __awaiter(this, void 0, void 0, function () {
            var url, multiQuotes;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(TOCJourneyConfigURL.multiquote);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: reqObj,
                            })];
                    case 1:
                        multiQuotes = _a.sent();
                        //const multiQuotes = JSON.parse(dummyMultiQuote);
                        return [2 /*return*/, MultiQuoteMapper(multiQuotes.data)];
                }
            });
        });
    };
    TOCJourney.prototype.placeNormalTrade = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, placeNormalTrade;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(TOCJourneyConfigURL.placeNormalTrade + "/" + req.userID);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req.body,
                                // encryption: encryptionEnable,
                            })];
                    case 1:
                        placeNormalTrade = _a.sent();
                        return [2 /*return*/, placeNormalTradeMapper(placeNormalTrade === null || placeNormalTrade === void 0 ? void 0 : placeNormalTrade.data)];
                }
            });
        });
    };
    TOCJourney.prototype.placeTradeComm = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, placeTradeCommData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL("".concat(TOCJourneyConfigURL.placeTradeComm, "/").concat(req.userID));
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req.body,
                                // encryption: encryptionEnable,
                            })];
                    case 1:
                        placeTradeCommData = _a.sent();
                        return [2 /*return*/, placeNormalTradeMapper(placeTradeCommData === null || placeTradeCommData === void 0 ? void 0 : placeTradeCommData.data)];
                }
            });
        });
    };
    TOCJourney.prototype.placeAmoTrade = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, placeNormalTrade;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(TOCJourneyConfigURL.amoTrade + "/" + req.userID);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req.amoBody,
                                // encryption: encryptionEnable,
                            })];
                    case 1:
                        placeNormalTrade = _a.sent();
                        return [2 /*return*/, placeNormalTradeMapper(placeNormalTrade === null || placeNormalTrade === void 0 ? void 0 : placeNormalTrade.data)];
                }
            });
        });
    };
    TOCJourney.prototype.placeAmoTradeComm = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, placeNormalTrade;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(TOCJourneyConfigURL.amoTradeComm + "/" + req.userID);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req.amoBody,
                                // encryption: encryptionEnable,
                            })];
                    case 1:
                        placeNormalTrade = _a.sent();
                        return [2 /*return*/, placeNormalTradeMapper(placeNormalTrade === null || placeNormalTrade === void 0 ? void 0 : placeNormalTrade.data)];
                }
            });
        });
    };
    TOCJourney.prototype.placeBracketTrade = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, placeNormalTrade;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL("".concat(TOCJourneyConfigURL.bracketOrder, "/").concat(req.userID));
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req.bracketTradeBody,
                                // encryption: encryptionEnable,
                            })];
                    case 1:
                        placeNormalTrade = _a.sent();
                        return [2 /*return*/, placeNormalTradeMapper(placeNormalTrade === null || placeNormalTrade === void 0 ? void 0 : placeNormalTrade.data)];
                }
            });
        });
    };
    TOCJourney.prototype.placeEsipTrade = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, placeNormalTrade;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(TOCJourneyConfigURL.esipOrder + "/" + req.userID);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req.EsipBody,
                                // encryption: encryptionEnable,
                            })];
                    case 1:
                        placeNormalTrade = _a.sent();
                        return [2 /*return*/, placeNormalTradeMapper(placeNormalTrade === null || placeNormalTrade === void 0 ? void 0 : placeNormalTrade.data)];
                }
            });
        });
    };
    TOCJourney.prototype.placeOfsTrade = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, placeOFSTrade;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(TOCJourneyConfigURL.PlaceOfsTrade + "/" + req.userID);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req.body,
                                // encryption: encryptionEnable,
                            })];
                    case 1:
                        placeOFSTrade = _a.sent();
                        return [2 /*return*/, OfsTradeMapper(placeOFSTrade)];
                }
            });
        });
    };
    TOCJourney.prototype.placeOfsModifyTrade = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, placeOFSTrade;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(TOCJourneyConfigURL.PlaceOfsTrade + "/" + req.userID);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req.body,
                                // encryption: encryptionEnable,
                            })];
                    case 1:
                        placeOFSTrade = _a.sent();
                        return [2 /*return*/, OfsTradeMapper(placeOFSTrade)];
                }
            });
        });
    };
    TOCJourney.prototype.orderDetails = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, orderDetails;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL((req === null || req === void 0 ? void 0 : req.isComm)
                            ? TOCJourneyConfigURL.orderDetailsComm + req.userID
                            : TOCJourneyConfigURL.orderDetails + req.userID);
                        url.searchParams.append((req === null || req === void 0 ? void 0 : req.isComm) ? "oID" : "nOID", req.orderID);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        orderDetails = _a.sent();
                        return [2 /*return*/, orderDetailsMapper(orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.data)];
                }
            });
        });
    };
    TOCJourney.prototype.checkMargin = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, checkMargin;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(TOCJourneyConfigURL.checkMargin + "/" + req.userID);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req.reqBody,
                                // encryption: encryptionEnable,
                            })];
                    case 1:
                        checkMargin = _a.sent();
                        return [2 /*return*/, CheckMarginMapper(checkMargin === null || checkMargin === void 0 ? void 0 : checkMargin.data)];
                }
            });
        });
    };
    TOCJourney.prototype.brokerCharge = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, brokerCharge;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(TOCJourneyConfigURL.brokerCharges + "/" + req.userID);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req.reqBody,
                                // encryption: encryptionEnable,
                            })];
                    case 1:
                        brokerCharge = _a.sent();
                        return [2 /*return*/, brokerChargesMapper(brokerCharge === null || brokerCharge === void 0 ? void 0 : brokerCharge.data)];
                }
            });
        });
    };
    TOCJourney.prototype.brokerChargeComm = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, brokerCharge;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(TOCJourneyConfigURL.brokerChargesComm + "/" + req.userID);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req.reqBody,
                                // encryption: encryptionEnable,
                            })];
                    case 1:
                        brokerCharge = _a.sent();
                        return [2 /*return*/, brokerChargesMapper(brokerCharge === null || brokerCharge === void 0 ? void 0 : brokerCharge.data)];
                }
            });
        });
    };
    TOCJourney.prototype.getRmsSublimits = function (userId) {
        return __awaiter(this, void 0, void 0, function () {
            var accType, url, rmsSubLimits;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.accountDetails.getAccTyp()];
                    case 1:
                        accType = _a.sent();
                        if (!(accType != "CO")) return [3 /*break*/, 3];
                        url = new URL(this.jusPayFlag
                            ? TOCJourneyConfigURL.rmsSubLimitsJusPay
                            : TOCJourneyConfigURL.rmsSubLimits + "/" + userId);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 2:
                        rmsSubLimits = _a.sent();
                        return [2 /*return*/, rmsSubLimits.data];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    TOCJourney.prototype.getLimits = function (userId) {
        return __awaiter(this, void 0, void 0, function () {
            var url, limitsData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(this.jusPayFlag
                            ? TOCJourneyConfigURL.limitsJusPay
                            : TOCJourneyConfigURL.limits + "/" + userId);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        limitsData = _a.sent();
                        return [2 /*return*/, limitsData.data];
                }
            });
        });
    };
    TOCJourney.prototype.getRmsHoldingDetails = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, rmsholdings;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(TOCJourneyConfigURL.rmsHolding + "/" + req.userId);
                        url.searchParams.append("sym", req.symbol);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        rmsholdings = _a.sent();
                        return [2 /*return*/, rmsholdings.data];
                }
            });
        });
    };
    TOCJourney.prototype.getTpinData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, tpinData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(TOCJourneyConfigURL.tpin);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                                // encryption: encryptionEnable,
                            })];
                    case 1:
                        tpinData = _a.sent();
                        return [2 /*return*/, tpinData.data];
                }
            });
        });
    };
    TOCJourney.prototype.proceedToAuthorize = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, authorizeData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(TOCJourneyConfigURL.authorize);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                                // encryption: encryptionEnable,
                            })];
                    case 1:
                        authorizeData = _a.sent();
                        // const authorizeData = JSON.parse(unauthorizedScripRmsHoldingApiResponse);
                        return [2 /*return*/, authorizeData.data];
                }
            });
        });
    };
    TOCJourney.prototype.AMOStatus = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, amoStatus;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url =
                            req.accType === "EQ"
                                ? new URL(TOCJourneyConfigURL.eq + TOCJourneyConfigURL.amo + req.exchange)
                                : new URL(TOCJourneyConfigURL.comm + TOCJourneyConfigURL.amo + req.exchange);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        amoStatus = _a.sent();
                        return [2 /*return*/, AMOStatus(amoStatus === null || amoStatus === void 0 ? void 0 : amoStatus.data)];
                }
            });
        });
    };
    TOCJourney.prototype.cancelPlaceOrder = function (req) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var url, userId, result;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, ((_a = this.accountDetails) === null || _a === void 0 ? void 0 : _a.getUserID())];
                    case 1:
                        userId = _b.sent();
                        url = req.isAmo
                            ? new URL(TOCJourneyConfigURL.cancelAmoOrder + "/" + userId)
                            : new URL(TOCJourneyConfigURL.cancelPlaceOrder + "/" + userId);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "PUT",
                                url: url.toString(),
                                body: {
                                    nstOID: req.orderId,
                                    curQty: req.curQty,
                                    flQty: req.flQty,
                                    empOrDependent: req.empOrDependent,
                                    trdSym: req.trdSym,
                                    sym: req.sym,
                                    action: req.action,
                                },
                            })];
                    case 2:
                        result = _b.sent();
                        return [2 /*return*/, result.data];
                }
            });
        });
    };
    TOCJourney.prototype.CoCancelPlaceOrder = function (req) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var url, userId, result;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, ((_a = this.accountDetails) === null || _a === void 0 ? void 0 : _a.getUserID())];
                    case 1:
                        userId = _b.sent();
                        url = req.isAmo
                            ? new URL(TOCJourneyConfigURL.CoCancelAmoOrder + "/" + userId)
                            : new URL(TOCJourneyConfigURL.CoCancelPlaceOrder + "/" + userId);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "PUT",
                                url: url.toString(),
                                body: { nstOID: req.orderId },
                            })];
                    case 2:
                        result = _b.sent();
                        return [2 /*return*/, result.data];
                }
            });
        });
    };
    TOCJourney.prototype.cancelEsipOrder = function (req) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var url, userId, result;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, ((_a = this.accountDetails) === null || _a === void 0 ? void 0 : _a.getUserID())];
                    case 1:
                        userId = _b.sent();
                        url = new URL(TOCJourneyConfigURL.cancelEsipOrder + "/" + userId);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: { sipNum: req.orderId },
                            })];
                    case 2:
                        result = _b.sent();
                        return [2 /*return*/, result.data];
                }
            });
        });
    };
    TOCJourney.prototype.modifyOrder = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = req.isAmo
                            ? new URL(TOCJourneyConfigURL.modifyAmoOrder + "/" + req.userID)
                            : new URL(TOCJourneyConfigURL.modifyOrder + "/" + req.userID);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "PUT",
                                url: url.toString(),
                                body: req.body,
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data];
                }
            });
        });
    };
    TOCJourney.prototype.coModifyOrder = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = req.isAmo
                            ? new URL(TOCJourneyConfigURL.coModifyAmoOrder + "/" + req.userID)
                            : new URL(TOCJourneyConfigURL.coModifyOrder + "/" + req.userID);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "PUT",
                                url: url.toString(),
                                body: req.body,
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data];
                }
            });
        });
    };
    TOCJourney.prototype.getUPIList = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(TOCJourneyConfigURL.upiList);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data];
                }
            });
        });
    };
    TOCJourney.prototype.getSpecificIPODetails = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(TOCJourneyConfigURL.specificIPO);
                        url.searchParams.append("co_code", req.co_code);
                        req.typ && url.searchParams.append("typ", req.typ);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data];
                }
            });
        });
    };
    TOCJourney.prototype.getSpecificNcdIpoDetails = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(TOCJourneyConfigURL.specificNcdIpoDetails);
                        url.searchParams.append("coCode", req.coCode);
                        url.searchParams.append("srNo", req.srNo);
                        url.searchParams.append("code", req.code);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    TOCJourney.prototype.getNcdIpoSeries = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(TOCJourneyConfigURL.ncdIpoSeries);
                        url.searchParams.append("coCode", req.coCode);
                        url.searchParams.append("srNo", req.srNo);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    TOCJourney.prototype.applyIPO = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(TOCJourneyConfigURL.applyIPO);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req === null || req === void 0 ? void 0 : req.body,
                                getGauth: req === null || req === void 0 ? void 0 : req.getGauth,
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data];
                }
            });
        });
    };
    TOCJourney.prototype.addClientDetailsNCd = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(TOCJourneyConfigURL.addClientDetailsNcd);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req === null || req === void 0 ? void 0 : req.body,
                                getGauth: req === null || req === void 0 ? void 0 : req.getGauth,
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result === null || result === void 0 ? void 0 : result.data];
                }
            });
        });
    };
    TOCJourney.prototype.getncdipoCheckPincode = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(TOCJourneyConfigURL.ncdIpoCheckPincode);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result === null || result === void 0 ? void 0 : result.data];
                }
            });
        });
    };
    TOCJourney.prototype.getIpoValidateUpi = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(TOCJourneyConfigURL.validateUpi);
                        url.searchParams.append("upi", req === null || req === void 0 ? void 0 : req.upi);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data];
                }
            });
        });
    };
    TOCJourney.prototype.getUserStatus = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(TOCJourneyConfigURL.userStatus);
                        url.searchParams.append("pan", req === null || req === void 0 ? void 0 : req.pan);
                        (req === null || req === void 0 ? void 0 : req.typ) && url.searchParams.append("typ", req === null || req === void 0 ? void 0 : req.typ);
                        (req === null || req === void 0 ? void 0 : req.val) && url.searchParams.append("val", String(req === null || req === void 0 ? void 0 : req.val));
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    TOCJourney.prototype.getAsmGsmStatus = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL("".concat(TOCJourneyConfigURL.asmGsmStatus).concat(req.symbol));
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    TOCJourney.prototype.exitAllBoOrder = function (req) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var userId, url, result;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, ((_a = this.accountDetails) === null || _a === void 0 ? void 0 : _a.getUserID())];
                    case 1:
                        userId = _b.sent();
                        url = new URL("".concat(TOCJourneyConfigURL.exitAllBoOrder).concat(userId));
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "DELETE",
                                url: url.toString(),
                                body: req,
                            })];
                    case 2:
                        result = _b.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    TOCJourney.prototype.getMFSwitchDetails = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(TOCJourneyConfigURL.mfSwitchDetail);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                                encryption: encryptionEnable,
                            })];
                    case 1:
                        data = _a.sent();
                        // const data = schemeDetails;
                        return [2 /*return*/, switchDetailsMapper(data)];
                }
            });
        });
    };
    TOCJourney.prototype.getMFSwitchDetailsFilter = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(TOCJourneyConfigURL.mfSwitchDetailsFilters);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                                encryption: encryptionEnable,
                            })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data];
                }
            });
        });
    };
    TOCJourney.prototype.mfModifyOrder = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(TOCJourneyConfigURL.mfModifyOrder);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "PUT",
                                url: url.toString(),
                                body: req,
                                encryption: encryptionEnable,
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return TOCJourney;
}());
export default TOCJourney;
